module.exports = __webpack_public_path__ + "img/credit-one-layout.2416c3d2.jpg";